import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q16 = ({ history }) => {
  const { t } = useTranslation();
  const Q16Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question16')}
      options={Q16Options}
      nextUrl="q17"
      screenName="q16"
    />
  );
};

export default Q16;
